import React from "react";
import { useField } from "formik";

import styles from './styles.module.scss'

export const FieldCheckbox = props => {
  const { id, checked } = props;

  const [field] = useField({
    ...props
  });

  // input classes
  const cls = [styles.CheckboxField_input];

  if (checked) {
    cls.push(styles.CheckboxField_input_checked);
  }

  return (
    <div className={styles.CheckboxField}>
      <div className={styles.CheckboxField_input_wrapper}>
        <input
          className={cls.join(' ')}
          { ...field }
          { ...props }
          type="checkbox"
        />
        <label htmlFor={id}>{id}</label>
      </div>
    </div>
  )
};
